import { takeEvery, all, put, call } from "redux-saga/effects"
import { DckActionTypes } from "dck-redux"

import * as ItemTypes from "../../items/types"
import * as authRequest from "../authRequest"
import ProcessTypes from "../../processes/types"
import { parseFetchError } from "../../../lib/utils"

function* loadUserRolesSaga() {

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_START,
    processCode: ProcessTypes.LOAD_USER_ROLES
  })
  let processResult

  try {
    const result = yield call(authRequest.makeAuthRequest, authRequest.GET_USER_ROLES)
    yield put({
      type: DckActionTypes.ITEMS_SET,
      itemType: ItemTypes.UserRole,
      data: result
    })

    processResult = { success: true, message: null }
  }
  catch (error) {
    yield put({
      type: DckActionTypes.ITEMS_SET,
      itemType: ItemTypes.UserRole,
      data: []
    })
    processResult = { success: false, message: parseFetchError(error).text }
  }

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_STOP,
    processCode: ProcessTypes.LOAD_USER_ROLES,
    result: processResult
  })
}

function* userRolesSaga() {
  yield all([
    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.UserRole,
      loadUserRolesSaga
    )
  ])
}

export default userRolesSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/items/userRoles.js